// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"05d6b75aa54f841f02c8","655":"516f7b44a9195c992227"}[chunkId] + ".js";
};